import McqQuestions from "./McqQuestions";
import AddQuestion from "./AddQuestion";
import EditQuestion from "./EditQuestion";

export const containers = {
  McqQuestions,
  AddQuestion,
  EditQuestion,
};



// WEBPACK FOOTER //
// ./src/modules/admin/mcqQuestions/containers/index.js